import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class ConfigService {
	constructor() {}

	apiBaseUrl = environment.apiBaseUrl;
	organizationName = environment.organizationName;
	authApiBaseUrl = environment.apiBaseUrl;
	confirmEmailCallbackUrl = environment.confirmEmailCallbackUrl;
	resetPasswordCallbackUrl = environment.resetPasswordCallbackUrl;
}
